import React from 'react';
import { Header } from '../../components/Header/Header';
import ServicesCart from '../../components/ServicesCart/ServicesCart';

export default function Services() {
  return (
    <div>
      <Header />
      <ServicesCart />
    </div>
  );
}
